import { generateStorageKey } from '@/utils';
import { APP_TOKEN_NAME } from '@/config/constants';
import Api from '../abstract';

export let UPLOAD_IMAGE = (params, successCallback, errorCallback) => {
  let url = `/user/upload/image`;
  let headers = {
    Authorization: `Bearer ${window.$cookies.get(generateStorageKey(APP_TOKEN_NAME))}`,
    'content-type': 'multipart/form-data'
  };
  let data = params.payload.data;
  return Api.post(url, data, { headers }).then(successCallback).catch(errorCallback);
};
